// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportModalFilter_root__3KO0L","footer":"ReportModalFilter_footer__1qK9w"};